module.exports = __webpack_public_path__ + "img/prsinvivo.9c5d85af.png";